"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const Icon_1 = __importDefault(require("../../../common/js/atoms/Icon"));
const ButtonSize_1 = __importDefault(require("../../../common/js/enums/ButtonSize"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const translation_1 = require("../../../common/js/helper/translation");
const Paths_1 = require("../../constants/Paths");
const history_1 = require("../../helper/history");
const RegistrationSuccess = (location) => {
    return (react_1.default.createElement("section", { className: "znd-registration-success" },
        react_1.default.createElement("div", { className: "znd-registration-success__container" },
            react_1.default.createElement("div", { className: "znd-registration-success__icon-container" },
                react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.check, className: 'znd-registration-success__icon' })),
            react_1.default.createElement("h1", { className: (0, classnames_1.default)('t-headline-1', 'znd-registration-success__title') }, (0, translation_1.t)('registration.success.title')),
            react_1.default.createElement("p", { className: (0, classnames_1.default)('t-subhead-small', 'znd-registration-success__text'), dangerouslySetInnerHTML: {
                    __html: (0, translation_1.t)('registration.success.text'),
                } }),
            react_1.default.createElement(Button_1.default, { variant: ButtonVariant_1.default.primary, size: ButtonSize_1.default.default, text: (0, translation_1.t)('registration.success.button'), className: "znd-registration-success__button", onClick: () => {
                    (0, history_1.pushHistory)(location.history, Paths_1.PATH_SHOP);
                } }))));
};
exports.default = (0, react_router_dom_1.withRouter)((0, mobx_react_1.observer)(RegistrationSuccess));
